module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id=\'device_details\'></div>\n<div id=\'settings\'></div>\n<div id=\'device_library_details\'></div>\n';
}
return __p;
};
